import useLocale from '../hooks/useLocale';

const NotFoundPage = (): JSX.Element => {
  const { t } = useLocale();
  return <div>{t.NOT_FOUND_PAGE}</div>;
};

export default NotFoundPage;
